import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate, Flex, Checkbox, Button, Icon } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Input from 'components/Inputs/input';
import { getConsentInfo, updateTenantServiceConsent, saveSelectedProductsAsNotes } from '../../actions/services';
import Card, { CardsContainer, CardTitle, CardFooter } from 'components/Cards/Card';
import { Spinner } from 'UI';
import Redirect from 'components/Redirect/Redirect';
import './_onboarding.scss';
import { appInsights } from 'lib/appInsights';
import * as microsoftTeams from "@microsoft/teams-js";
import getEnvironment from 'lib/env';

var TermsManagement = /*#__PURE__*/function (_Component) {
  _inherits(TermsManagement, _Component);

  var _super = _createSuper(TermsManagement);

  function TermsManagement(props) {
    var _this;

    _classCallCheck(this, TermsManagement);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderRedirect", function () {
      if (_this.state.redirect) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: _this.state.redirect
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(1).then(function () {
            resolve(1);
          });
        }
      });
    });

    _this.state = {
      title: 'Haldor',
      consentInfos: [],
      showConsentRequireMessage: false,
      consentRequiredMessage: _this.props.translate('If you need any help or have any questions about the approval of permissions for Haldor Education, please contact our support at support@haldor.se'),
      loading: true
    };
    window.onPopupDataReceived = _this.getResults.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TermsManagement, [{
    key: "getResults",
    value: function () {
      var _getResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
        var itemIndex, tenantService;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                response = JSON.parse(response);
                appInsights.trackTrace({
                  message: "Onboarding | O365 Admin page has given admin consent"
                }, {
                  response: response,
                  consentInformation: this.state.consentInfos
                });
                itemIndex = this.state.consentInfos.findIndex(function (element) {
                  return element.state == response.state;
                });

                if (!(itemIndex > -1)) {
                  _context.next = 10;
                  break;
                }

                this.state.consentInfos[itemIndex].status = response.consent;
                tenantService = {
                  serviceId: this.state.consentInfos[itemIndex].serviceId,
                  consentActive: response.consent
                };
                appInsights.trackTrace({
                  message: "Onboarding | Update Admin consent on tenantService"
                }, {
                  response: response,
                  consentInformation: this.state.consentInfos,
                  tenantService: tenantService
                });
                _context.next = 9;
                return this.props.updateTenantServiceConsent(tenantService);

              case 9:
                this.setState({
                  consentInfos: this.state.consentInfos,
                  loading: false
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getResults(_x) {
        return _getResults.apply(this, arguments);
      }

      return getResults;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      appInsights.trackTrace({
        message: "Onboarding | O365 Admin page was initiated"
      });
      this.setState({
        isLoading: false
      });
      this.props.getConsentInfo().then(function () {
        if (_this2.props.consentInfo) {
          _this2.setState({
            consentInfos: _this2.props.consentInfo,
            loading: false
          });
        }
      });
    }
  }, {
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "getAdminConsentOnService",
    value: function getAdminConsentOnService(consentItem) {
      var itemIndex = this.state.consentInfos.findIndex(function (element) {
        return element.state == consentItem.state;
      });

      if (itemIndex > -1) {
        this.state.consentInfos[itemIndex].loading = true;
        this.setState({
          consentInfos: this.state.consentInfos
        });
      }

      this.getAdminConsent(consentItem);
    }
  }, {
    key: "onSave",
    value: function onSave() {
      this.props.saveSelectedProductsAsNotes();

      if (this.props.onSubmit) {
        this.props.onSubmit(3);
      }
    }
  }, {
    key: "getAdminConsent",
    value: function getAdminConsent(consentElement) {
      var _this3 = this;

      this.setState({
        showConsentRequireMessage: false,
        loading: true
      });

      if (this.inIframe()) {
        microsoftTeams.authentication.authenticate({
          url: consentElement.uri + "&redirect_uri=" + window.location.origin + '/authenticate/callback?platform=teams'
        }).then(function (result) {
          var data = localStorage.getItem(result);
          localStorage.removeItem(result);
          var tokenResult = JSON.parse(data);

          _this3.getResults(tokenResult);
        })["catch"](function (error) {
          console.log(error);

          _this3.setState({
            showConsentRequireMessage: true
          });
        });
      } else {
        var consentTab = window.open(consentElement.uri + "&redirect_uri=" + window.location.origin + '/authenticate/callback?platform=browser', "_blank", "width=600,height=1200"); //this method will catch if the browser has blocked popups

        setTimeout(function () {
          if (consentTab.closed) {
            this.setState({
              showConsentRequireMessage: true
            });
          }
        }.bind(this), 200);
      }

      return;
    }
  }, {
    key: "showButtonGroup",
    value: function showButtonGroup() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.consentInfos.findIndex(function (element) {
          return element.status == false;
        }) > -1,
        type: "primary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: this.onSave.bind(this)
      }, this.props.translate('Continue')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick() {
          _this4.goBack();
        }
      }, this.props.translate('Back')));
    }
  }, {
    key: "showConsentedCard",
    value: function showConsentedCard(element) {
      return /*#__PURE__*/React.createElement("div", {
        className: "onboarding-consent-card",
        key: element.state
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        style: {
          width: '2rem',
          height: '2rem'
        },
        src: "/dist/svg/check_green_ico.svg"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          height: '2rem',
          marginLeft: '0.5rem',
          marginTop: '0.35rem'
        }
      }, element.name + " " + this.props.translate('is approved'))));
    }
  }, {
    key: "getConsentCard",
    value: function getConsentCard(element) {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "onboarding-consent-card active",
        key: element.state,
        onClick: function onClick() {
          _this5.getAdminConsentOnService(element);
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        style: {
          width: '2rem',
          height: '2rem'
        },
        src: "/dist/svg/check_grey_ico.svg"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          height: '2rem',
          marginLeft: '0.5rem',
          marginTop: '0.35rem'
        }
      }, this.props.translate('Click here to approve') + " " + element.name)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      if (this.state.redirect) {
        return this.renderRedirect();
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var product = getEnvironment().id;
      var productName = 'Haldor Education';

      if (product === 'haldor_planning') {
        productName = "Haldor Planning";
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          background: '#FFF'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '98%',
          paddingTop: '3%',
          paddingBlockStart: '3%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 2
        }
      }, /*#__PURE__*/React.createElement("h2", {
        style: {
          textAlign: 'left'
        }
      }, " ", this.props.translate('Approve permissions for {0}').replace('{0}', productName), " "), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1.0rem',
          marginBottom: '1.0rem'
        }
      }, this.props.translate('Haldor Education is a collection of educational services that expands the functionality in Teams and facilitates for school staff. In order for you to use the services, you need to gain permission to certain parts of the organisation’s Microsoft Office 365 tenant to enable Haldor to access data via Microsoft Graph APIs.')), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '0.5rem'
        }
      }, this.props.translate('Haldor is a Microsoft partner that complies with GDPR legislation and processes its data based on the highest information and security standards. Haldor only uses data when it is necessary.')))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }), this.state.consentInfos != null && this.state.consentInfos.map(function (element) {
        return element.status ? _this6.showConsentedCard(element) : _this6.getConsentCard(element);
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red',
          marginBottom: '0,5rem'
        }
      }, this.state.showConsentRequireMessage ? this.state.consentRequiredMessage : null), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "left",
          justifyContent: "left",
          marginTop: '1.5rem'
        }
      }, this.showButtonGroup())));
    }
  }]);

  return TermsManagement;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    selectedServices: state.Services.selectedServices,
    currentUser: state.user.currentUser,
    consentInfo: state.Services.consentInfo
  };
}

export default connect(mapStateToProps, {
  getConsentInfo: getConsentInfo,
  updateTenantServiceConsent: updateTenantServiceConsent,
  saveSelectedProductsAsNotes: saveSelectedProductsAsNotes
})(TermsManagement);